export default "__VITE_ASSET__BjsPI7x$__"